import {userConstants} from '../constants/user.constants.js';
import {SAVE_OR_UPDATE_USER, UPDATE_USER} from "../constants";

let keycloakUser = JSON.parse(localStorage.getItem('_keycloakUser'));
let loy3User = JSON.parse(localStorage.getItem('_loy3User'));
const initialState = keycloakUser || loy3User
    ? {
        loggedIn: true,
        userProfile: keycloakUser,
        loy3Profile: loy3User,
        authToken: loy3User ? loy3User.token : ""
    }
    : {};

export const authentication = (state = initialState, action) => {
    switch (action.type) {
        case userConstants.LOGIN_REQUEST:
            return {
              ...state,
              loggingIn: true
            };
        case userConstants.LOGIN_SUCCESS:
            return {
                loggingIn: false,
                loggedIn: action.authResponse.authenticated,
                authentication: action.authResponse.user
            };
        case userConstants.LOGIN_FAILURE:
            return {};
        case userConstants.LOGOUT:
            return {};
        case userConstants.STORE_USER:
            return {
                ...state,
                userProfile: action.userProfile
            };
        case userConstants.LOY3_LOGIN_SUCCESS:
            return {
                ...state,
                authToken: action.authResponse.token,
                locale: action.authResponse.locale,
                loy3Profile: action.authResponse,
                loggedIn: true,
                initialModalVisible: true,
            };
        case userConstants.LOY3_LOGIN_FAILURE:
            return {
                ...state,
                loginFailure: true,
                loginFailureMsg: action.payload,
                loggedIn: false
            };
        case userConstants.LOY3_SSO_LOGIN_FAILURE:
            return {
                ...state,
                loginFailure: true,
                ssoLoginFailure: true,
                loginFailureMsg: action.payload
            };
        case userConstants.LOY3_LOAD_DATA_SUCCESS:
            return {
                ...state,
                loy3ProfileData: action.loy3ProfileData
            };
        case UPDATE_USER:
            return {
                ...state,
                user: action.user
            };
        case userConstants.GET_REGISTRATION_INFO:
            return {
                ...state,
                registrationInfo: action.registrationInfo
            };
        case SAVE_OR_UPDATE_USER:
            return {
                ...state,
                registrationInfo: action.payload
            };
        case userConstants.INITIAL_MODAL_VISIBLE:
            return {
                ...state,
                initialModalVisible: action.initialModalVisible,
            }
        default:
            return state
    }
};
